module.exports = __webpack_public_path__ + "img/rodriguez-draw.f62e4f8c.jpg";